import axios from 'axios';
import { getCart, getCartCount } from 'js/modules/sidecart';
import { quickAddProductToCart, addCartPromoCode } from 'helpers/api';
import { formatMoney, addDarkBackground, removeDarkBackground } from 'helpers/utils';

export default {
  name: 'productcard',
  data() {
    return {
      HOST: '/',
      product: { Inventory: { Product: {} } },
      amount: '',
      extendInfo: false,
      extendedDescriptions: false,
      typingTimer: 0,
      productImage: '',
      showListPrice: false,
    };
  },
  props: ['part', 'promo', 'logo'],

  mounted() {
    axios
      .get(
        `${this.HOST}customapi/Product/Single?part=${this.part}&allowSuper=false&promo=${this.promo}`,
      )
      .then((response) => {
        this.product = response.data;
        this.productImage = response.data.PrimaryImageUrl
          ? this.product.PrimaryImageUrl.replace('--/', '--/w_465/')
          : `/assets/brands/logos/${this.product.Inventory.Product.ManufacturerCode}.png`;
      })
      .catch((err) => err.response);
  },
  methods: {
    async bindClick() {
      const cartOrder = [];
      cartOrder.push({
        productId: this.product.Inventory.Product.Id,
        qty: Number(this.amount),
      });
      const status = await addCartPromoCode(this.promo);
      const res = await quickAddProductToCart(cartOrder);
      getCartCount();
      getCart();
      this.amount = '';
    },
    getActualPriceTotal() {
      return formatMoney(this.product.Inventory.Product.ActualCost * this.amount);
    },
    getActualPrice() {
      return formatMoney(this.product.Inventory.Product.ActualCost);
    },
    getListPrice() {
      return formatMoney(this.product.Inventory.Product.ListPrice);
    },
    getDealerPrice() {
      return formatMoney(this.product.Inventory.Product.DealerCost);
    },
    onlyNumber(e) {
      const keyCode = e.keyCode ? e.keyCode : e.which;
      if (keyCode < 48 || keyCode > 57) {
        e.preventDefault();
      }
    },
    beginTypingTimer() {
      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(this.calculateQuantity, 1000);
    },
    clearTypingTimer() {
      clearTimeout(this.typingTimer);
    },
    calculateQuantity() {
      if (this.product.Inventory.Product.SellpackQuantity > 1) {
        const mod = this.amount % this.product.Inventory.Product.SellpackQuantity;
        this.amount =
          mod === 0
            ? this.amount
            : this.amount + (this.product.Inventory.Product.SellpackQuantity - mod);
      }
    },
    showMore() {
      addDarkBackground();
      this.extendInfo = true;
      setTimeout(() => {
        this.extendedDescriptions = true;
      }, 200);
    },
    collapseDescription() {
      this.extendedDescriptions = false;
      setTimeout(() => {
        this.extendInfo = false;
      }, 400);
      removeDarkBackground();
    },
  },
  template: `
    <div class="card-single-wrapper" v-bind:class="{ active__card: extendInfo }">
      <div class="product-view__short">
        <div class="card-carousel__primary-img">
          <img class="product-image" :src="this.productImage" />
        </div>
        <div class="card-single-info">
          <div>
            <div class="card-carousel__info">
              <img v-if="this.logo !== ''" class="card-carousel__img-asset-logo" :src="this.logo" />
              <section class="initial-product__info" v-if="!extendInfo">
                <h3 class="card-carousel__info__part">{{ product.Inventory.Product.PartNumber }}</h3>
                <p class="card-carousel__info__title">{{ product.ShortDescription }}</p>
                <p class="read__more" v-on:click="showMore()">Read More</p>
              </section>
              <div class="extended-product__info" v-bind:class="{ active: extendInfo }">
                <h3 class="brand-name">{{ product.Brand }}</h3>
                <h4>{{ product.ProductTitle }}</h4>
                <p style="margin-top: 20px;"><b>mpn:</b> {{ product.Inventory.Product.PartNumber }}</p>
                <p class="short-description">{{ product.ShortDescription }}</p>
              </div>
              <div class="product-view__long">
                <div class="long-description" v-bind:class="{ showDescription: extendedDescriptions }"
                  v-html="product.Description">{{ product.Description }}</div>
              </div>
              <div class="card-carousel__price">
                <span class="card-carousel__price__actual">{{ getActualPrice() }}</span>
                <span v-if="this.product.Inventory.Product.ActualCost !== this.product.Inventory.Product.DealerCost" class="card-carousel__price__list">{{ getDealerPrice() }}</span>
                <span v-if="this.product.Inventory.Product.ActualCost === this.product.Inventory.Product.DealerCost" class="card-carousel__price__list-price">(List Price: {{ getListPrice() }})</span>
              </div>
              <span class="package-note" v-if="product.Inventory.Product.PackageNotes">{{ product.Inventory.Product.PackageNotes }}
              </span>
            </div>
            <div class="card-carousel__form">
              <input class="card-carousel__form__input" type="text" name="qty" placeholder="Qty."
                autocomplete="off" v-model.number="amount" v-on:keypress="onlyNumber" v-on:keyup="beginTypingTimer" v-on:keydown="clearTypingTimer" />
              <button v-on:click="bindClick()" class="card-carousel__btn js--quick-atc-single">Add to
                Cart <span v-if="amount !== '' && amount > 0" class="total-cost"><i class="fa fa-angle-right"></i> {{ getActualPriceTotal() }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="exit-product__view collapse-product__view" v-on:click="collapseDescription()">
        <span class="exit-button" v-bind:class="{ showExit_button:  extendedDescriptions}"><i class="fa fa-times" aria-hidden="true"></i></span>
      </div>
    </div>
    `,
};
